import React from "react";
import ApprovalProcess from "./CreateApproval";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";

const modules = [
    "survey_report",
    "invoice_outgoing"
    
];

const NewApprovalIndex = () => {
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Settings" },
            { name: "Approval Status" },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
        {modules.map((mod) => (
          <div key={mod} className="p-3">
            <ApprovalProcess moduleName={mod} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewApprovalIndex;
